module.exports = __webpack_public_path__ + "images/icon_play_active_17349d84d269fc96ab8e120862a0c9a6.svg";